
import React from 'react';
import { Mail } from 'lucide-react';

type RequestCardPartyProps = {
  type: 'sent' | 'received';
  isCandidat: boolean;
  recruiterName?: string | null;
  recruiterEmail?: string | null;
  recruiterCompany?: string | null;
  candidateName: string;
  candidateEmail: string;
};

export const RequestCardParty = ({ 
  type,
  isCandidat,
  recruiterName,
  recruiterEmail,
  recruiterCompany,
  candidateName,
  candidateEmail
}: RequestCardPartyProps) => {
  return (
    <div className="text-gray-600 mb-3">
      {isCandidat ? (
        <div className="flex items-center gap-1">
          <Mail size={14} />
          <span>
            {type === 'sent' ? 
              `Envoyé à : ${recruiterName || recruiterEmail || 'Recruteur'}` : 
              `De : ${recruiterName || recruiterEmail || 'Recruteur'}`
            }
            {recruiterCompany && ` (${recruiterCompany})`}
          </span>
        </div>
      ) : (
        <div className="flex items-center gap-1">
          <Mail size={14} />
          <span>
            {type === 'sent' ? 
              `Envoyé à : ${candidateName} <${candidateEmail}>` : 
              `De : ${candidateName} <${candidateEmail}>`
            }
          </span>
        </div>
      )}
    </div>
  );
};
